import { Component, OnInit, Input, OnChanges, OnDestroy } from "@angular/core";

import { CartItemGroup } from "app/plan/plan.models";

@Component({
    selector: "cart-item-group",
    templateUrl: "./cart-item-group.component.html",
    styleUrls: ["./cart-item-group.component.scss"],
    standalone: false
})
export class CartItemGroupComponent implements OnInit, OnChanges, OnDestroy {
	@Input() cartItemGroup: CartItemGroup;
	nbnflow = false;
	constructor() {}

	ngOnInit() {
		console.log("CartItemGroupComponent CartItemGroup", this.cartItemGroup);
	}

	ngOnDestroy() {}

	ngOnChanges(changes: any) {
		console.log("changes", changes);
	}
}
